module.exports = "/images/black-0.8.png?66751bcb45f027167131b081788d81ff";